import {get, isString} from "lodash"
import API from "@irati/utils/services/API"
import endpoints from "../endpoints"

/**
 *
 * @param userSurvey
 * @returns {Promise<any>}
 */
export const fetchUserSurvey = (tenant, userSurvey) => {
  const id = isString(userSurvey) ? userSurvey : get(userSurvey, "id", "") || ""
  return API.get(endpoints.userSurvey(tenant, id), {tenant, id}, {unAuth: true}).then((response) => response.data)
}

/**
 *
 * @param userSurvey
 * @param data
 * @returns {Promise<any>}
 */
export const patchUserSurvey = (tenant, userSurvey, data) => {
  const {id} = userSurvey
  return API.patch(endpoints.userSurvey(tenant, id), data, userSurvey.Etag, {unAuth: true})
}

/**
 * Helper to run common requests
 *
 * @param userSurvey
 * @param data
 * @returns {Promise<any>}
 */
export const patchAndFetchUserSurvey = (tenant, userSurvey, data) => {
  return patchUserSurvey(tenant, userSurvey, data).then(() => {
    return fetchUserSurvey(tenant, userSurvey)
  })
}

export default {
  fetchUserSurvey,
  patchUserSurvey,
  patchAndFetchUserSurvey
}
